import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ActionButton,
  getTheme,
  IIconProps,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  Label,
  mergeStyleSets,
  Stack,
} from '@fluentui/react';
import { uPrinceTheme } from '../../../theme';
import ImagePreview from './ImagePreview';
import client from '../../api';

const theme = getTheme();

const iconButtonStyles = {
  root: { color: uPrinceTheme.palette.themePrimary },
  rootHovered: { color: theme.palette.neutralDark },
};
const uploadIcon: IIconProps = {
  iconName: 'Upload',
  styles: iconButtonStyles,
};

const stackStyles: IStackStyles = { root: { padding: 0 } };
const stackItemStyles: IStackItemStyles = {
  root: {
    display: 'flex',
    height: 40,
    alignItems: 'flex-start',
  },
};

const stackEditbarItemStyles: IStackItemStyles = {
  root: {
    display: 'flex',
    height: 45,
    alignItems: 'flex-end',
  },
};

const stackTokens: IStackTokens = {
  childrenGap: 15,
  padding: 10,
};

const classNames = mergeStyleSets({
  wrapper: {
    // height: '100vh',
    position: 'relative',
    maxHeight: 'inherit',
  },
  pane: { maxWidth: 400 },
  textContent: { padding: '15px 10px' },
  actionIcon: {
    padding: 5,
    cursor: 'pointer',
  },
  labelRightWrapper: {
    textAlign: 'end',
    selectors: { '@media(max-width: 1100px)': { textAlign: 'start' } },
  },
  actionButton: {
    color: uPrinceTheme.palette.themePrimary,
    cursor: 'pointer',
  },
  labelRightIcon: {
    display: 'inline-block',
    verticalAlign: 'bottom',
    paddingBottom: 2,
    paddingRight: 5,
  },
});

const CustomFileUploader = (props: {
  isImage?: boolean;
  label: any;
  uploadedImages: any;
  uploadUrl: string;
  /* setJournalImage:(
        type:string,response:any) => void; */
  onSaveSuccess: (response: any) => void;
  onSaveError?: () => void;
  isDelete?: boolean;
  handleImageDelete?: (id: string) => void;
  disable?: boolean
}) => {
  const { t } = useTranslation();

  const [selectedFiles, setFiles]: any = useState(props.uploadedImages);
  const [transition, setTransition]: any = useState(false);
  const inputFileRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setFiles(props.uploadedImages);
  }, [props.uploadedImages]);

  const showFileDialog = () => {
    inputFileRef.current && inputFileRef.current.click();
  };

  const uploadFiles = (files: FileList | null) => {
    // files && context.uploadItems(files);
    if (selectedFiles) {
      const currentFiles = selectedFiles.map((item: any) => {
        return { image: item.image, id: item.id, isLast: false, extension: item.extension ? item.extension : null };
      });
      if (files) {
        let parts = files[0].name.split('.');
        const size = files[0].size;
        // alert(size);
        setFiles(
          currentFiles.concat([
            { image: URL.createObjectURL(files[0]), id: null, isLast: true, extension: parts[parts.length - 1] },
          ]),
        );
        setTransition(true);
        saveImage(files, currentFiles);
      }
    }
  };

  const saveImage = (files: any, currentFiles: any) => {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const data = new FormData();
    if (files) {
      for (const file of files) {
        data.append('image', file);
      }
    }
    client.post(props.uploadUrl, data, { headers: headers }).then(
      (response: any) => {
        setTransition(false);
        props.onSaveSuccess(response.data.result);
      },

      (error: any) => {
        alert(JSON.stringify(error));
        setTransition(false);
        setFiles(props.uploadedImages);
      },
    );
  };

  return (
    <div>
      <div className="input-file">
        <input
          style={{ display: 'none' }}
          ref={inputFileRef}
          type="file"
          accept={props.isImage ? 'image/*' : '*'}
          multiple={false}
          onChange={(e) => {
            uploadFiles(e.target.files);
            // props.setJournalImage('link',e)
          }}
        />
      </div>
      <Stack
        horizontal
        horizontalAlign="space-between"
        styles={stackStyles}
        tokens={stackTokens}
      >
        <Stack.Item styles={stackItemStyles}>
          <Label>{props.label}</Label>
        </Stack.Item>
        <Stack.Item styles={stackEditbarItemStyles}>
          <ActionButton
            className={classNames.actionButton}
            iconProps={uploadIcon}
            allowDisabledFocus
            disabled={props.disable}
            onClick={() => {
              showFileDialog();
            }}
          >
            <Label className={classNames.actionButton}>{t('upload')}</Label>
          </ActionButton>
        </Stack.Item>
      </Stack>
      <div>
        <ImagePreview
          transition={transition}
          uploadedImages={selectedFiles}
          handleImageDelete={(id: string) => {
            if (props.handleImageDelete) {
              props.handleImageDelete(id);
            }
          }}
          disable={props.disable}
          isDelete={props.isDelete}
        />
      </div>
    </div>
  );
};

export default CustomFileUploader;
